module.exports = __webpack_public_path__ + "img/ring_r_0_1_null.06f55352.png";